import { Pipe, PipeTransform } from '@angular/core';
import { Customer } from '../../classes/customer';

@Pipe({
  name: 'customerVatNumberFilter',
  pure: false
})
export class CustomerVatNumberFilterPipe implements PipeTransform {

  transform(customerList: Array<Customer>, filterValue: string): any {
    if (!customerList || !filterValue) {
      return customerList;
    }
    return customerList.filter(customer => customer.VATNumber.toLowerCase().indexOf(filterValue.toLowerCase()) !== -1);
  }

}
